import { CATEGORY_SHORT_LABELS, SUB_CATEGORY_LABELS } from './incidentLabels';
import type { IncidentCategory, IncidentSubCategory } from '../../types/extranet-api.types';

interface IncidentCategoryChipProps {
  category: IncidentCategory;
  subCategory?: IncidentSubCategory;
  compact?: boolean;
}

export const IncidentCategoryChip = ({ category, subCategory, compact = false }: IncidentCategoryChipProps) => (
  <span className="inline-flex items-baseline gap-1.5 text-sm">
    <span className="text-zinc-900">{CATEGORY_SHORT_LABELS[category]}</span>
    {subCategory && !compact ? (
      <>
        <span className="text-zinc-300" aria-hidden>
          ·
        </span>
        <span className="text-zinc-500">{SUB_CATEGORY_LABELS[subCategory]}</span>
      </>
    ) : null}
  </span>
);
